import RevertDefault from '../../blocks/revert-default/revert-default';
import isEmpty from 'mout/lang/isEmpty';
import alertService from '@jetbrains/ring-ui/components/alert-service/alert-service';
import Utils from '../../blocks/utils/utils';

const LICENSE_LINKS = {
  youtrack: {
    requestKey: 'https://www.jetbrains.com/shop/eform/evaluation?product=YTDN10000',
    purchase: 'https://www.jetbrains.com/youtrack/buy/#server'
  },
  upsource: {
    requestKey: 'https://www.jetbrains.com/shop/eform/evaluation?product=USN10000',
    purchase: 'https://www.jetbrains.com/upsource/buy'
  },
  'upsource-frontend': {
    requestKey: 'https://www.jetbrains.com/shop/eform/evaluation?product=USN10000',
    purchase: 'https://www.jetbrains.com/upsource/buy'
  }
};

export default class LicenseController {
  /*@ngInject*/
  constructor($log, $q, $location, $scope, i18n, installerResource, startInstallation, fields, wizardInfo) {
    this.$log = $log;
    this.$scope = $scope;
    this.$location = $location;
    this.i18n = i18n;
    this.installerResource = installerResource;
    this.startInstallationFn = startInstallation;
    this.wizardInfo = wizardInfo;
    this.fields = fields.LICENSE_KEYS;
    this.LicenseResource = installerResource.licenseSettings;
    this.dataShouldChecked = false;
    this.welcomePageAvailable = wizardInfo.isUpgradeAvailable;
    this.showLimitations = false;
    this.utils = new Utils();

    this.license = installerResource.getSingletonOf('licenseSettings');

    this.licenseDefault = installerResource.licenseSettingsDefault.get();
    this.licenseDefaultForUpgrade = installerResource.licenseSettingsDefaultsForUpgrade.get();

    $q.all([this.license.$promise, this.licenseDefault.$promise, this.licenseDefaultForUpgrade.$promise]).
      then(() => {
        if (this.isUpgrade()) {
          this.revertDefault = new RevertDefault(this.license, this.licenseDefaultForUpgrade);
          this.defaultFreeLicense = new RevertDefault(this.license, this.licenseDefault);
        } else {
          this.revertDefault = new RevertDefault(this.license, this.licenseDefault);
        }
      }).
      catch(errResponse => {
        this.$log.debug('Error at license checking', errResponse);
      });
  }

  startInstallation() {
    this.isSaving = true;

    this.startInstallationFn().
      catch(err => {
        if (err) {
          alertService.error(this.installerResource.extractErrorMessage(err));
        }
      }).
      finally(() => {
        this.isSaving = false;
      });
  }

  hasLimitations() {
    return !isEmpty(this.license[this.fields.LIMITATIONS]);
  }

  toggleLimitationsShow() {
    this.showLimitations = !this.showLimitations;
  }

  shouldCheck() {
    return this.dataShouldChecked;
  }

  setUnchecked() {
    this.dataShouldChecked = true;
  }

  getRequestKeyLink() {
    return LICENSE_LINKS[this.license.id] && LICENSE_LINKS[this.license.id].requestKey;
  }

  getPurchaseLink() {
    return LICENSE_LINKS[this.license.id] && LICENSE_LINKS[this.license.id].purchase;
  }

  saveLicense() {
    const licenseResource = new this.LicenseResource();
    licenseResource[this.fields.USER_NAME] = this.license[this.fields.USER_NAME];
    licenseResource[this.fields.KEY] = this.license[this.fields.KEY];

    return licenseResource.$save().
      then(response => {
        this.dataShouldChecked = false;
        this.utils.deepCopy(this.license, response);
      }).
      catch(errResponse => {
        this.$log.debug('Error at license checking', errResponse);
      });
  }

  getErrorForKey() {
    if (this.license[this.fields.STATUS] === 'INVALID_KEY') {
      return this.getStatusMessage(this.license[this.fields.STATUS]);
    }
  }

  getErrorForUserName() {
    if (this.license[this.fields.STATUS] === 'INVALID_USER_NAME') {
      return this.getStatusMessage(this.license[this.fields.STATUS]);
    }
  }

  getErrorMessage() {
    if (!this.getErrorForKey() && !this.getErrorForUserName(this.license) && this.license[this.fields.STATUS] !== 'OK') {
      return this.getStatusMessage(this.license[this.fields.STATUS]);
    }
  }

  errorsExist() {
    return typeof this.license !== 'undefined' && this.license.status !== 'OK';
  }

  revertToDefault() {
    this.revertToDefaultLicense(this.revertDefault);
  }

  setFreeLicense() {
    this.revertToDefaultLicense(this.defaultFreeLicense);
  }

  revertToDefaultLicense(defaultLicense) {
    defaultLicense.revertToDefault();
    this.saveLicense(this.license);
  }

  reloadHubStepAndGoBack() {
    this.installerResource.getSingletonOf('hubSettings').$get().
      then(() => this.$location.path('/install/hub'), () => this.installerResource.clearSingletonOf('hubSettings'));
  }

  blockFinish($error) {
    return (Object.keys($error).length > 0) || this.dataShouldChecked || this.errorsExist();
  }

  getStatusMessage(status) {
    const i18n = this.i18n;
    const messages = {
      INVALID_KEY: i18n('Key is not valid'),
      INVALID_USER_NAME: i18n('User name is not valid'),
      EXPIRED: i18n('License is expired'),
      FREE_UPGRADE_PERIOD_EXPIRED: i18n('Free upgrade period has expired'),
      GENERATION_DATE_IN_FUTURE: i18n('License generation date is in the future'),
      HOSTED_SOLUTION: i18n('License is valid for a hosted solution, only'),
      INVALID_PRODUCT_TYPE: i18n('License was issued for another product'),
      INVALID_BUILD_NUMBER: i18n(' License was issued for another build number/type'),
      INVALID_VERSION: i18n('License was issued for a different version')
    };
    return messages[status] || status;
  }

  isUpgrade() {
    return this.$location.path().includes('upgrade/license');
  }

  shouldShowSetFreeLicenseLink() {
    return this.defaultFreeLicense && this.defaultFreeLicense.isChanged && !angular.equals(this.defaultFreeLicense.defaultModel, this.revertDefault.defaultModel);
  }

  isUpgradeOnlyMode() {
    return this.wizardInfo.isUpgradeDetected && this.wizardInfo.isDetectedUpgradeSourceValid;
  }
}



// WEBPACK FOOTER //
// ./src/pages/license/license__controller.js